import 'antd/lib/select/style';
//# sourceMappingURL=index.js.map